module.exports = __webpack_public_path__ + "assets/img/7a54-mg.svg";